export default "__VITE_ASSET__B4mt_TW$__"